import unescapedText from 'I18n/utils/unescapedText';
import UIApplication from 'UIComponents/app/UIApplication';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { parse } from 'hub-http/helpers/params';
import { getThemeDetailsSlug } from 'marketplace-assets-base/selectors/themeDetails';
import { getPublicRootUrl } from 'marketplace-assets-base/utils/urls';
import { getAppShortlink, getCmsFreeSignupUrl } from 'marketplace-ui-assets-core/utils/urls';
import MarketingNav from 'marketplace-ui-common/components/MarketingNav';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const AppContainer = ({
  children,
  name
}) => {
  const {
    pathname,
    search
  } = useLocation();
  const query = parse(search.slice(1));
  const themeDetailsSlug = useSelector(getThemeDetailsSlug) || undefined;
  const marketingNavLocation = useMemo(() => ({
    pathname: `${getPublicRootUrl()}${pathname}`,
    search
  }), [pathname, search]);
  return /*#__PURE__*/_jsx(UIApplication, {
    name: name,
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      children: /*#__PURE__*/_jsx(MarketingNav, {
        location: marketingNavLocation,
        loginUrl: getAppShortlink({
          pathname,
          query,
          theme: themeDetailsSlug
        }),
        navCtaUrl: getCmsFreeSignupUrl(themeDetailsSlug),
        navCtaText: unescapedText('marketplace-assets-ui.storefront.publicNav.navCtaText'),
        children: /*#__PURE__*/_jsx(Box, {
          grow: 1,
          shrink: 1,
          minBlockSize: "100vh",
          children: children
        })
      })
    })
  });
};
export default AppContainer;